import { render, staticRenderFns } from "./dialogalert.vue?vue&type=template&id=0af93a99&scoped=true&"
import script from "./dialogalert.vue?vue&type=script&lang=js&"
export * from "./dialogalert.vue?vue&type=script&lang=js&"
import style0 from "./dialogalert.vue?vue&type=style&index=0&id=0af93a99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af93a99",
  null
  
)

export default component.exports